import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';




type Behaviours = 'static' | 'absolute';
type Positions = 'left' | 'right';
type Colors = 'yellow' | 'red' | 'blue';

@Component({
    selector: 'app-badge',
    imports: [],
    templateUrl: './badge.component.html',
    styleUrl: './badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeComponent {
    @Input() behaviour: Behaviours = 'absolute';
    @Input() position: Positions = 'right';
    @Input() color: Colors = 'blue';

    @HostBinding('attr.aria-label') @Input() label: string = '';
    @HostBinding('attr.aria-live') aria = 'polite';

    @HostBinding('class') get classes() {
        return {
            [`behaviour--${this.behaviour}`]: true,
            [`position--${this.position}`]: true,
            [`color--${this.color}`]: true
        };
    }
}
